// src/components/store/sections/product-cards/Variant87CyberHudMatrixEmeraldMintCard.tsx
"use client";

import Image from "next/image";
import Link from "next/link";
import { Star, ShoppingCart, Zap, Check } from "lucide-react";
import { UniversalProductCardProps, useCardActions } from "./useCardActions";

export default function Variant87CyberHudMatrixEmeraldMintCard({
  product,
  subdomain = "nextlook",
}: UniversalProductCardProps) {
  const {
    productImg,
    productName,
    productUrl,
    categoryName,
    rating,
    currentPrice,
    discountPercent,
    added,
    handleAddToCart,
    handleBuyNow,
  } = useCardActions(product, subdomain);

  return (
    <div className="w-full h-full rounded-[28px] bg-[#0c0d14] border border-white/15 p-4 text-white shadow-xl hover:shadow-2xl transition-all duration-300 flex flex-col justify-between relative overflow-hidden group select-none">
      <div className="absolute -top-12 -right-12 w-32 h-32 rounded-full bg-gradient-to-br from-emerald-500 to-teal-600 blur-2xl opacity-35 pointer-events-none" />
      <div>
        <div className="flex items-center justify-between text-[10px] font-mono mb-2.5">
          <span className="px-2 py-0.5 rounded bg-white/10 text-white/90 uppercase">HUD #87</span>
          <span className="px-2 py-0.5 rounded bg-gradient-to-r from-emerald-500 to-teal-600 text-white font-black">-{discountPercent}%</span>
        </div>
        <Link href={productUrl} className="relative w-full h-44 rounded-2xl bg-white/5 border border-white/10 flex items-center justify-center p-3 mb-3 block">
          <Image src={productImg} alt={productName} fill unoptimized className="object-contain p-2 group-hover:scale-110 transition-transform duration-500 drop-shadow-[0_12px_20px_rgba(0,0,0,0.7)]" />
        </Link>
        <div className="flex items-center justify-between text-[10px] text-slate-400 font-mono">
          <span className="truncate max-w-[120px] uppercase">{categoryName}</span>
          <span className="flex items-center gap-0.5 text-amber-400">
            <Star className="w-3 h-3 fill-amber-400" /> {rating.toFixed(1)}
          </span>
        </div>
        <Link href={productUrl} className="block mt-1">
          <h3 className="text-sm font-black text-white truncate hover:text-cyan-300">{productName}</h3>
        </Link>
        <div className="text-lg font-black font-mono text-white mt-1">
          ৳{currentPrice.toLocaleString()}
        </div>
      </div>

      <div className="flex items-center gap-2 pt-3 mt-2 border-t border-white/10">
        <button
          type="button"
          onClick={(e) => handleAddToCart(e)}
          className="flex-1 py-2 rounded-xl bg-gradient-to-r from-emerald-500 to-teal-600 text-white font-black text-[10px] uppercase tracking-wider shadow-md active:scale-95 transition-all cursor-pointer flex items-center justify-center gap-1"
        >
          {added ? <Check className="w-3.5 h-3.5" /> : <ShoppingCart className="w-3.5 h-3.5" />}
          <span>{added ? "Added" : "Deploy Cart"}</span>
        </button>
        <button
          type="button"
          onClick={(e) => handleBuyNow(e)}
          className="p-2 rounded-xl bg-white/10 hover:bg-white/20 text-white active:scale-95 transition-all cursor-pointer"
        >
          <Zap className="w-3.5 h-3.5 text-amber-300 fill-amber-300" />
        </button>
      </div>
    </div>
  );
}
